import React from "react";
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell footer-inner">
        <div className="footer-brand">
          <Link to="/" className="wordmark" aria-label="Floro home">
            <img src="/logo.svg" alt="Floro" className="wordmark-logo" />
          </Link>
          <span className="footer-url">florolabs.com</span>
        </div>
        <p className="footer-legal">Not a diagnostic device. © 2026 Floro Health Inc.</p>
      </div>
    </footer>
  );
}
